import AdminHttpClient from './AdminHttpService';

function list(search) {
    return AdminHttpClient.get('/companies', { params: search ? { search } : {} });
}

function getById(id) {
    return AdminHttpClient.get(`/companies/${id}`);
}

function toggleStatus(id) {
    return AdminHttpClient.put(`/companies/${id}/toggle/status`);
}

function getUsers(companyId) {
    return AdminHttpClient.get(`/companies/${companyId}/users`);
}

function createUser(companyId, data) {
    return AdminHttpClient.post(`/companies/${companyId}/users`, data);
}

function toggleUserStatus(companyId, userId) {
    return AdminHttpClient.put(`/companies/${companyId}/users/${userId}/toggle/status`);
}

function resetUserPassword(companyId, userId, data) {
    return AdminHttpClient.put(`/companies/${companyId}/users/${userId}/reset-password`, data);
}

function getUsage(companyId) {
    return AdminHttpClient.get(`/companies/${companyId}/usage`);
}

function grantUsageCredit(companyId, payload) {
    return AdminHttpClient.post(`/companies/${companyId}/usage/grant`, payload);
}

export default { list, getById, toggleStatus, getUsers, createUser, toggleUserStatus, resetUserPassword, getUsage, grantUsageCredit };
